export default __webpack_public_path__ + "assets/models/539e312f1b74e483acc8a6b23a8a9f0c.glb";